if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        // Build the arrows before super.show() so trapFocus() includes them on the first open.
        this.ensureNav();
        super.show(opener);
        this.showActiveMedia();
      }

      // Direct media children of the modal content. Images, <deferred-media> (video/external
      // video) and the 3D-model wrapper all carry data-media-id, keyed off the real media.id —
      // the same id the gallery's opener button uses, so the clicked item leads.
      get mediaItems() {
        const content = this.querySelector('.product-media-modal__content');
        if (!content) return [];
        return Array.from(content.querySelectorAll(':scope > [data-media-id]'));
      }

      // Inject the prev/next arrows once, into the dialog (NOT the content — the variant-media
      // gallery swaps the content's innerHTML on variant change, which would wipe them).
      ensureNav() {
        const dialog = this.querySelector('[role="dialog"]');
        if (!dialog) return;

        if (!this.navReady) {
          const caret =
            '<span class="svg-wrapper"><svg class="icon icon-caret" viewBox="0 0 10 6" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646A.5.5 0 0 0 .646 1.354l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708Z" fill="currentColor"></path></svg></span>';

          const makeButton = (direction, label) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = `product-media-modal__nav product-media-modal__nav--${direction}`;
            button.setAttribute('aria-label', label);
            button.innerHTML = caret;
            button.addEventListener('click', (event) => {
              event.preventDefault();
              this.navigate(direction === 'prev' ? -1 : 1);
            });
            // Stop ModalDialog's media-modal "click anywhere to close" pointerup from firing
            // when the arrows are clicked.
            button.addEventListener('pointerup', (event) => event.stopPropagation());
            return button;
          };

          this.navPrev = makeButton('prev', 'Previous');
          this.navNext = makeButton('next', 'Next');
          dialog.append(this.navPrev, this.navNext);

          this.addEventListener('keydown', (event) => {
            if (!this.hasAttribute('open')) return;
            if (event.key === 'ArrowLeft') {
              event.preventDefault();
              this.navigate(-1);
            } else if (event.key === 'ArrowRight') {
              event.preventDefault();
              this.navigate(1);
            }
          });

          this.navReady = true;
        }

        // Hide the arrows when there's nothing to navigate between.
        const multiple = this.mediaItems.length > 1;
        this.navPrev.hidden = !multiple;
        this.navNext.hidden = !multiple;
      }

      navigate(direction) {
        const items = this.mediaItems;
        if (items.length < 2) return;
        let index = items.findIndex((element) => element.classList.contains('active'));
        if (index < 0) index = 0;
        const nextIndex = (index + direction + items.length) % items.length; // loop around
        this.activate(items[nextIndex]);
      }

      activate(item) {
        if (!item) return;
        // Pause any media (e.g. a playing video) before switching the visible item.
        window.pauseAllMedia();
        this.mediaItems.forEach((element) => element.classList.toggle('active', element === item));
      }

      showActiveMedia() {
        const openerId = this.openedBy?.getAttribute('data-media-id');
        const items = this.mediaItems;
        const target = items.find((element) => element.getAttribute('data-media-id') === openerId) || items[0];
        this.activate(target);
      }
    }
  );
}
